module.exports = __webpack_public_path__ + "static/img/mb-02.37be062.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h2/mb-02.jpg
// module id = O17Q
// module chunks = 1